<template>
  <div class="search-result">
    <van-nav-bar
      title="搜索结果"
      left-arrow
      @click-left="onBack"
      fixed
    />

    <div class="search-header">
      <div class="search-info">
        关键词: <strong>{{ $route.query.q }}</strong>
        <van-tag v-if="$route.query.drive" size="small" type="primary" style="margin-left: 8px">
          {{ getDriveName($route.query.drive) }}
        </van-tag>
      </div>
      <span class="count">共 {{ uniqueList.length }} 条结果</span>
    </div>

    <van-loading v-if="loading && list.length === 0" class="loading" />

    <div class="result-list" v-else>
      <div
        v-for="item in uniqueList"
        :key="item.id"
        class="result-item"
        @click="openLink(item.shareLink)"
      >
        <div class="item-cover" v-if="item.cover">
          <img :src="item.cover" :alt="item.title" />
        </div>
        <div class="item-info">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-desc">{{ item.desc }}</div>
          <div class="item-meta">
            <van-tag size="small" type="success">{{ item.drive }}</van-tag>
            <span class="category" v-if="item.category">{{ item.category }}</span>
          </div>
        </div>
      </div>

      <div v-if="uniqueList.length === 0 && !loading" class="empty">
        未找到相关资源
      </div>
    </div>

    <div class="poll-tip" v-if="polling">
      <van-loading size="20px" />
      <span>正在加载更多...</span>
    </div>
  </div>
</template>

<script>
import { searchResources, searchPoll } from '../utils/api';

export default {
  name: 'SearchResult',
  data() {
    return {
      list: [],
      loading: false,
      polling: false,
      pollCount: 0,
      maxPollCount: 15
    };
  },
  computed: {
    uniqueList() {
      const seen = new Set();
      return this.list.filter(item => {
        if (seen.has(item.id)) {
          return false;
        }
        seen.add(item.id);
        return true;
      });
    }
  },
  mounted() {
    this.fetchSearchResult();
  },
  methods: {
    async fetchSearchResult() {
      const { q, drive } = this.$route.query;
      if (!q) return;

      this.loading = true;
      try {
        const res = await searchResources({ q, drive, limit: 200 });
        if (res.code === 0 && res.data) {
          const data = res.data;
          
          if (data.list && data.list.length > 0) {
            this.list = data.list;
          }
          
          if (data.complete === false && data.search_id) {
            this.pollCount = 0;
            this.pollResults(data.search_id);
          }
        } else {
          this.$toast(res.msg || '搜索失败');
        }
      } catch (error) {
        this.$toast('搜索服务异常');
      } finally {
        this.loading = false;
      }
    },
    async pollResults(searchId) {
      if (this.pollCount >= this.maxPollCount) {
        return;
      }

      this.polling = true;
      this.pollCount++;

      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        
        const res = await searchPoll({
          id: searchId,
          theme: 'btlm-V65',
          limit: 200
        });

        if (res.code === 0 && res.data) {
          const data = res.data;
          
          if (data.list && data.list.length > 0) {
            this.list = [...this.list, ...data.list];
          }
          
          if (data.complete === false && data.search_id) {
            this.pollResults(searchId);
          }
        }
      } catch (error) {
        console.error('Poll error:', error);
      } finally {
        this.polling = false;
      }
    },
    onBack() {
      this.$router.back();
    },
    openLink(url) {
      if (url) {
        //新开浏览器标签打开链接
        window.open(url, '_blank');
      }
    },
    getDriveName(drive) {
      const driveMap = {
        quark: '夸克网盘',
        baidu: '百度网盘',
        ali: '阿里网盘'
      };
      return driveMap[drive] || drive;
    }
  }
};
</script>

<style scoped>
.search-result {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
}

.search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #fff;
  font-size: 14px;
}

.search-info {
  color: #666;
}

.count {
  color: #999;
}

.loading {
  text-align: center;
  padding: 20px;
}

.result-list {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-item {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  gap: 12px;
  cursor: pointer;
}

.item-cover {
  width: 80px;
  height: 100px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f0f0;
}

.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-desc {
  font-size: 12px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 4px;
}

.item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.category {
  font-size: 12px;
  color: #999;
}

.empty {
  text-align: center;
  padding: 40px;
  color: #999;
}

.poll-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: #666;
  font-size: 14px;
}
</style>
